// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.37 6.7C14.98 9.71 13.41 12.73 10.6 13.96C7.8 15.18 4.51 14.28 2.72 11.8C0.93 9.31 1.12 5.91 3.18 3.64C5.23 1.37 8.6 0.84 11.25 2.37',
  'M14.5 2.8L8 9.3L6.1 7.4',
];
